// extracted by mini-css-extract-plugin
module.exports = {"acc":"style_acc__Aod6_","btnText":"style_btnText__Rh43K"};